import React, { memo, lazy, Suspense } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { largeMediaQuery } from '../../common/utilities/sizeHelpers';

const NationalOutlookScreenHeader  = lazy(() => import('./nationalOutlookScreenComponents/nationalOutlookScreenHeader'));
const NationalOutlookScreenVideoView  = lazy(() => import('./nationalOutlookScreenComponents/nationalOutlookScreenVideoView'));

export const NationalOutlookScreen = () => {
    return (
        <Wrapper>
            <Container>
                <Suspense fallback={<LoadingUI>Loading...</LoadingUI>}>
                    <NationalOutlookScreenHeader />
                    <NationalOutlookScreenVideoView />
                </Suspense>
            </Container>
        </Wrapper>
    );
};

NationalOutlookScreen.displayName = 'NationalOutlookScreen';

NationalOutlookScreen.propTypes = {
    videoUrl: PropTypes.string,
    videoPoster: PropTypes.string,
    pageId: PropTypes.string,
    adPositionId: PropTypes.string,
    platformCode: PropTypes.string,
    prerollAdUrl: PropTypes.string
};

const LoadingUI = styled.div`
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: #ffffff;
    width: 100%;
    height: auto;
    margin: 13px;
    @media ${largeMediaQuery} {
        margin: 40px;
        max-width: 1098px;
    }
`;
